import type { AdminUser } from '@/state/admin-users';
import type { Class } from '@/state/class-groups';

export type ScheduleInstructor = NonNullable<
  NonNullable<Class['instructor_schedules']>[number]['admin_user']
>;

export const findListedInstructor = (
  listed: AdminUser[] | undefined,
  adminUserId: string
) => listed?.find((instructor) => instructor.admin_user_id === adminUserId);
